<template>
  <div class="container mt-5">
    <div class="row">
      <div class="col-sm-3"></div>
      <div class="col-sm-6">
        <h1 class="text-center font-weight-bold">Forgot Password</h1>
        <h6 class="text-center mt-3 font-weight-bold">Masukan Email Yang Terdaftar</h6>

        <div class="form-group mt-4">
          <input
            v-model="email"
            type="email"
            class="form-control"
            id="exampleInputEmail1"
            aria-describedby="emailHelp"
            placeholder="Enter email"
          />
        </div>
        <div class="text-center">
          <button
            v-on:click="requestForgot"
            type="submit"
            class="btn btn-success font-weight-bold"
          >LANJUT</button>
        </div>
      </div>
      <div class="col-sm-3"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ForgotPasword",
  components: {},
  methods: {
    requestForgot() {
      this.$axios.post("/api/v1/priority/user/request-forgot", {
        email: this.email
      })
      .then(result => {
        this.$swal({
          text: "Success request forgot password, email already sent."
        });
      })
      .catch(err => {
        this.$swal({
          text: "Failed, user not exist"
        });
      });
    }
  },
  data() {
    return {
      email: ""
    };
  }
};
</script>

<style>
</style>